var _path, _path2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChnhb(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 49,
    viewBox: "0 0 48 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 10.3496C0 4.82676 4.47715 0.349609 10 0.349609H38C43.5229 0.349609 48 4.82676 48 10.3496V38.3496C48 43.8725 43.5228 48.3496 38 48.3496H10C4.47715 48.3496 0 43.8725 0 38.3496V10.3496Z",
    fill: "url(#paint0_linear_4168_5840)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31 26.3496C32.49 24.8896 34 23.1396 34 20.8496C34 19.3909 33.4205 17.992 32.3891 16.9605C31.3576 15.9291 29.9587 15.3496 28.5 15.3496C26.74 15.3496 25.5 15.8496 24 17.3496C22.5 15.8496 21.26 15.3496 19.5 15.3496C18.0413 15.3496 16.6424 15.9291 15.6109 16.9605C14.5795 17.992 14 19.3909 14 20.8496C14 23.1496 15.5 24.8996 17 26.3496L24 33.3496L31 26.3496Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4168_5840",
    x1: 24,
    y1: 0.349609,
    x2: 24,
    y2: 48.3496,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#155DFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#60A5FA"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChnhb);
export default __webpack_public_path__ + "static/media/CHNHB.be92e954beaa6c53eb1e6b480c1fe21b.svg";
export { ForwardRef as ReactComponent };